import { matchPath } from 'react-router-dom';

export const requiredScopeOf = <S extends string>(
  pagesScopes: readonly (readonly [string, S])[],
  pathname: string,
): S | undefined =>
  pagesScopes.find(([path]) => matchPath(path, pathname))?.[1];
